var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMagnifying(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.09 43.5C52.53 36.08 50.92 25.66 43.5 20.22C36.08 14.79 25.66 16.39 20.22 23.81C14.79 31.23 16.39 41.65 23.81 47.09C29.67 51.39 37.65 51.38 43.51 47.09C43.59 47.19 43.67 47.29 43.76 47.38L53.62 57.24C54.62 58.24 56.24 58.24 57.24 57.24C58.24 56.24 58.24 54.62 57.24 53.62L47.38 43.76C47.29 43.67 47.19 43.58 47.09 43.5ZM47.75 33.65C47.75 41.43 41.44 47.74 33.66 47.74C25.88 47.74 19.57 41.43 19.57 33.65C19.57 25.87 25.88 19.56 33.66 19.56C41.44 19.56 47.75 25.87 47.75 33.65Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMagnifying);
export default __webpack_public_path__ + "static/media/icon_magnifying.efd2d80ab30346b72b60c3ad8537dd75.svg";
export { ForwardRef as ReactComponent };